<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <v-layout column class="elevation-4">
        <v-flex xs12 sm10 md8 lg6>
          <v-card>
            <v-card-title>General Information</v-card-title>
            <v-card-text>
              <v-list two-line>
                <!-- <draggable v-model="info" @start="drag=true" @end="drag=false"> -->
                  <v-list-item v-for="data in info" :key="data.name">
                    <v-list-item-content>
                      <v-list-item-title>{{data.name}}</v-list-item-title>
                      <v-list-item-subtitle >{{data.value}}</v-list-item-subtitle>
                    </v-list-item-content>
                  
                  </v-list-item>
                  <!-- <div v-for="element in myArray" :key="element.id">{{element.name}}</div> -->
                <!-- </draggable> -->
             
            </v-list>`
            </v-card-text>
           
          </v-card>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
//import firebase from 'firebase';
import { mapState } from 'vuex';
import draggable from 'vuedraggable';
export default {
  name: 'Information',
  data () {
    return {
      info:[
        {name:"School Hours (Office)",value:"7am-3pm"},
        {name:"School Hours",value:"7:45am-2:05pm"},
        {name:"Office Phone",value:"952-431-8370"},
        {name:"Attendance/Absences",value:"952-431-8375"},
        {name:"Principal",value:"Christine Evans"},
        {name:"Assistant Administrator",value:"Rachel Chamly"},
        {name:"Principal's Secretary",value:"Kari Wartick"},
        {name:"Child Study Secretary",value:"Kristin Rutherford"},
        {name:"Building Secretary",value:"Amy Bresnahan"},
      ]
    }
  },
  methods: {
    
  },
  computed: {
    ...mapState({
          loggedIn: state => state.loggedIn,
          isAdmin: state => state.isAdmin
        })
  },
  mounted: function() {
    // firebase.firestore().collection('admin').doc('information').get().then((doc) => {
    //   let info = doc.data().data;
    //   this.info = info;
    //   //this.committeeList = pto_config.committes;
    // });
  },
  components: {
    draggable,
  }
}
</script>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
